export const OPEN_DIALOG = "OPEN_DIALOG";
export const CLOSE_DIALOG = "CLOSE_DIALOG";
export function closeDialog() {
  return {
    type: CLOSE_DIALOG,
    payload: {},
  };
}
export function openDialog(song = {}) {
  return {
    type: OPEN_DIALOG,
    payload: { song },
  };
}
